

import { Box, Card, Grid, Typography } from "@mui/material";
import { SuggestionSimulatorComponentForCampaign } from './suggestionSimulatorComponentForCampaign';
import { MediaHandler } from "../../rcsManagement/rcsTemplates/simulator/MediaHandler";


export function RichCardStandAloneCampaignSimulator({ contentMessage, campaignSimulator }) {
    const standaloneCard = contentMessage.richCard.standaloneCard;
    const cardContent = standaloneCard.cardContent;
    const media = cardContent.media;

    // Helper to get media height
    const getMediaHeight = () => {
        return media.height === "SHORT" ? "100px" : "150px";
    };
    function getMediaTypeFromUrl(mediaUrl) {
        if (!mediaUrl) return "";

        const extension = mediaUrl.split(".").pop().toLowerCase();

        const imageTypes = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
        const videoTypes = ["mp4", "webm", "ogg", "mov", "avi", "mkv", "video/mp4"];
        const docTypes = ["application/pdf", "pdf"];
        if (imageTypes.includes(extension)) return "image/jpeg";
        if (videoTypes.includes(extension)) return "video/mp4";
        if (docTypes.includes(extension)) return "application/pdf";

        return "unknown";
    }

    // Helper to prepare media object for MediaHandler
    const getMediaObject = () => {


        return {
            url: media.contentInfo.fileUrl,
            type: getMediaTypeFromUrl(media.contentInfo.fileUrl)
        };
    };

    // Helper to prepare thumbnail object for MediaHandler
    const getThumbnailObject = () => {
        return media.contentInfo.thumbnailUrl
            ? { url: media.contentInfo.thumbnailUrl }
            : null;
    };

    // Vertical Card Layout
    const VerticalCard = () => (
        <Grid sx={{ display: "flex" }}>
            <Card sx={{
                border: "1px solid Grey",
                minHeight: "6vh",
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column"
            }}>
                {/* Media Section */}
                <Grid fullWidth>
                    <MediaHandler
                        media={getMediaObject()}
                        thumbnail={getThumbnailObject()}
                        height={getMediaHeight()}
                        width="100%"
                        iconPosition="center"
                    />
                </Grid>

                {/* Content Section */}
                <Grid padding={2}>
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                    >
                        {cardContent.title}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                    >
                        {cardContent.description}
                    </Typography>

                    {/* Suggestions Section */}
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        flexDirection: "column"
                    }}>
                        {cardContent.suggestions.map((suggestion, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center"
                                }}
                            >
                                <SuggestionSimulatorComponentForCampaign suggestion={suggestion} />
                                {index + 1 < cardContent.suggestions.length && (
                                    <hr style={{
                                        width: "60%",
                                        border: "1px solid black",
                                        margin: 3
                                    }} />
                                )}
                            </Box>
                        ))}
                    </Box>
                </Grid>
            </Card>
        </Grid>
    );

    // Horizontal Card Layout
    const HorizontalCard = () => {
        const isRightAligned = standaloneCard.cardAlignment === "RIGHT";

        return (
            <Card sx={{
                border: "1px solid Grey",
                minHeight: "12vh",
                width: "100%",
                display: "flex",
                margin: 3
            }}>
                <Grid container>
                    {/* Left Media (when not right-aligned) */}
                    {!isRightAligned && (
                        <Grid item md={4}>
                            <MediaHandler
                                media={getMediaObject()}
                                thumbnail={getThumbnailObject()}
                                height="100%"
                                width="100%"
                                iconPosition="left"
                            />
                        </Grid>
                    )}

                    {/* Content Section */}
                    <Grid item md={8} padding={2}>
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                        >
                            {cardContent.title}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{ lineBreak: "auto", wordBreak: "break-word" }}
                        >
                            {cardContent.description}
                        </Typography>

                        {/* Suggestions Section */}
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            flexDirection: "column",
                            mt: 2
                        }}>
                            {cardContent.suggestions.map((suggestion, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        mt: index > 0 ? 1 : 0
                                    }}
                                >
                                    <SuggestionSimulatorComponentForCampaign suggestion={suggestion} />
                                    {index + 1 < cardContent.suggestions.length && (
                                        <Box
                                            sx={{
                                                width: "60%",
                                                height: "1px",
                                                bgcolor: "divider",
                                                my: 1
                                            }}
                                        />
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Grid>

                    {/* Right Media (when right-aligned) */}
                    {isRightAligned && (
                        <Grid item md={4}>
                            <MediaHandler
                                media={getMediaObject()}
                                thumbnail={getThumbnailObject()}
                                height="100%"
                                width="100%"
                                iconPosition="right"
                            />
                        </Grid>
                    )}
                </Grid>
            </Card>
        );
    };

    return (
        <Grid
            container
            sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: campaignSimulator ? "90%" : "50%"
            }}
        >
            {standaloneCard.cardOrientation === "VERTICAL" && <VerticalCard />}
            {standaloneCard.cardOrientation === "HORIZONTAL" && <HorizontalCard />}
        </Grid>
    );
}